import React from "react";
import { useSelector } from "react-redux";

import MappingWindow from "../mapping/MappingWIndow";

function ProductMappings() {
  const {
    mapping: {
      defaultMappings: { productFieldMappings: mappings },
    },
    hubspot: {
      hubspotDropdownFields: { productFieldMappings: hsFields },
      loading: hubspotLoading,
    },
    tripletex: {
      tripletexDropdownFields: { productFieldMappings: txFields },
      loading: txLoading,
    },
  } = useSelector((state) => state.mapping);

  return (
    <div>
      <MappingWindow
        mapping={mappings}
        hubspotDropdownFields={hsFields}
        tripletexDropdownFields={txFields}
        mappingsFor="productFieldMappings"
        hubspotLoading={hubspotLoading}
        txLoading={txLoading}
      />
    </div>
  );
}

export default ProductMappings;
